import {BaseEvent} from "./BaseEvent";

export class ReloadDataEvent extends BaseEvent {
  public static NAME = 'reloadData';

  constructor() {
    super(ReloadDataEvent.NAME);
  }
}
